<template>
  <div
    class="mdg"
    :class="`mdg--${tone}`"
    role="img"
    :aria-label="`${percent}% of the man-day budget used`"
  >
    <div class="mdg__fill" :style="{ width: `${fillWidth}%` }"></div>
    <div
      v-if="overWidth"
      class="mdg__over"
      :style="{ left: `${budgetAt}%`, width: `${overWidth}%` }"
    ></div>
    <span
      v-for="tick in ticks"
      :key="tick"
      class="mdg__tick"
      :style="{ left: `${tick}%` }"
    ></span>
    <span
      v-if="percent > 100"
      class="mdg__budget"
      :style="{ left: `${budgetAt}%` }"
    ></span>
  </div>
</template>

<script>
// Man-days used against budget. Ticks sit at the 25/50/75% alert stages. Past
// 100% the bar rescales to the overrun, with a marker where the budget ran
// out, so 242% reads differently from 104%.
export default {
  props: {
    percent: { type: Number, required: true },
  },
  computed: {
    scale() {
      return Math.max(this.percent, 100);
    },
    budgetAt() {
      return (100 / this.scale) * 100;
    },
    fillWidth() {
      return (Math.min(Math.max(this.percent, 0), 100) / this.scale) * 100;
    },
    overWidth() {
      return this.percent > 100 ? ((this.percent - 100) / this.scale) * 100 : 0;
    },
    ticks() {
      return [25, 50, 75].map((stage) => (stage / this.scale) * 100);
    },
    tone() {
      if (this.percent >= 100) return "over";
      if (this.percent >= 75) return "watch";
      return "track";
    },
  },
};
</script>

<style scoped>
.mdg {
  position: relative;
  height: 8px;
  min-width: 96px;
  border-radius: 4px;
  overflow: hidden;
  background: #e4e9f0;
}
.mdg__fill,
.mdg__over {
  position: absolute;
  top: 0;
  bottom: 0;
}
.mdg__fill {
  left: 0;
}
.mdg--track .mdg__fill {
  background: #15489e;
}
.mdg--watch .mdg__fill {
  background: #e8650f;
}
.mdg--over .mdg__fill {
  background: #e7a9a9;
}
.mdg__over {
  background: #c62828;
}
.mdg__tick {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  margin-left: -1px;
  background: #fff;
  opacity: 0.85;
}
.mdg__budget {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  margin-left: -1px;
  background: #1c2534;
}
</style>
